import { ModalCancelOrder } from './ui/ModalCancelOrder.jsx'
import './ui/ModalCancelOrder.scss'

export default ModalCancelOrder